import { ScreenType, useScreenType } from "@redotech/react-util/screen";
import {
  ExchangeVariant,
  ReturnProduct,
} from "@redotech/redo-model/draft-return/draft-return-items";
import { CurrencyContext } from "@redotech/redo-web/currency";
import * as classNames from "classnames";
import { memo, useContext } from "react";
import * as chooseItems from "../choose-items.module.css";
import * as productCss from "./product.module.css";

export const ProductData = memo(function ProductData({
  isExpanded,
  expandedProductsLength,
  product,
  variant,
}: {
  isExpanded: boolean;
  expandedProductsLength: number;
  product: ReturnProduct;
  variant?: ExchangeVariant;
}) {
  const size = useScreenType();
  const { formatCurrency } = useContext(CurrencyContext);

  const data = variant
    ? {
        image: variant.image || product.image,
        originalPrice: variant.price,
        discountPrice: variant.price,
        title: product.title,
        subtitle: variant.title,
      }
    : {
        image: product.image,
        originalPrice: product.price,
        discountPrice: product.returnValue,
        title: product.title,
        subtitle: product.variantTitle,
      };

  const priceComponent = (
    <div className={productCss.priceContainer}>
      {/* {currentItemBeingReturned?.items?.length > 1 && <>Total Price:</>} */}
      {data.originalPrice !== data.discountPrice && (
        <div
          className={classNames(
            productCss.price,
            productCss.light,
            productCss.voided,
          )}
        >
          {formatCurrency(data.originalPrice)}
        </div>
      )}
      <div className={classNames(productCss.price, productCss.light)}>
        {formatCurrency(data.discountPrice)}
      </div>
    </div>
  );

  return (
    <div>
      {size === ScreenType.DESKTOP ? (
        <div className={chooseItems.productInfoContent}>
          {data.image && (
            <img
              alt={product.variantData?.variants?.[0]?.title || ""}
              className={productCss.cardImage}
              src={data.image}
            />
          )}
          <div className={productCss.productName}>
            <div>
              {data.title}{" "}
              {isExpanded &&
                expandedProductsLength > 0 &&
                `- bundle (${expandedProductsLength} products)`}
            </div>
          </div>
          <div className={productCss.variantTitle}>
            {data.subtitle && data.subtitle !== "Default Title" ? (
              <div>
                {data.subtitle}
                {priceComponent}
              </div>
            ) : (
              <div>Quantity: 1</div>
            )}
            {/*In the future if we want to handle multiple at a time we can change this*/}
            {/*<div>{`Quantity: 1`}</div>*/}
          </div>
        </div>
      ) : (
        <div className={chooseItems.productInfoContent}>
          {data.image && (
            <img
              alt={product.variantData?.variants?.[0]?.title || ""}
              className={productCss.cardImage}
              src={data.image}
            />
          )}
          <div className={productCss.productName}>
            <div>
              {data.title}{" "}
              {isExpanded &&
                expandedProductsLength > 0 &&
                `- bundle (${expandedProductsLength} products)`}
            </div>
            <div className={productCss.variantTitle}>
              {data.subtitle && data.subtitle !== "Default Title" ? (
                <div>{data.subtitle}</div>
              ) : (
                <div>Quantity: 1</div>
              )}
              {/*In the future if we want to handle multiple at a time we can change this*/}
              {/*<div>{`Quantity: 1`}</div>*/}
            </div>
          </div>
        </div>
      )}
    </div>
  );
});
